import React from "react";
import styled from "styled-components";
import { GroundTruth, getPromptTypeKoreanName } from "common/models/types";
import { Button, COLOR_SYSTEM, Text } from "components/atoms";
import { getDateStringFromToday } from "utils/TimeUtil";

interface GroundTruthRowProps {
  groundTruth: GroundTruth & { patient?: any };
  onEdit: (groundTruth: GroundTruth) => void;
  onDelete: (id: number) => void;
}

const GroundTruthRow: React.FC<GroundTruthRowProps> = ({ groundTruth, onEdit, onDelete }) => {
  const { patient } = groundTruth;

  return (
    <TableRow>
      <Cell>
        <PatientInfo>
          <PatientId>환자#{groundTruth.patientId}</PatientId>
          {patient && (
            <PatientDetails>
              {patient.birthDate} /{" "}
              {patient.gender === "M" ? "남" : patient.gender === "F" ? "여" : patient.gender}
            </PatientDetails>
          )}
        </PatientInfo>
      </Cell>
      <Cell>{getPromptTypeKoreanName(groundTruth.promptType)}</Cell>
      <Cell>
        <Text numberOfLines={3} textType="Caption">
          {groundTruth.expectedContent}
        </Text>
      </Cell>
      <Cell>{getDateStringFromToday({ date: groundTruth.updatedAt })}</Cell>
      <Cell>
        <ActionButtons>
          <Button
            size="Small"
            type="Text"
            variant="Outlined"
            color="Secondary"
            onClick={() => onEdit(groundTruth)}
          >
            수정
          </Button>
          <Button
            size="Small"
            type="Text"
            variant="Contained"
            color="Negative"
            onClick={() => groundTruth.id && onDelete(groundTruth.id)}
          >
            삭제
          </Button>
          <Button 
            size="Small" 
            type="Text" 
            variant="Ghost" 
            color="Secondary"
            onClick={() => window.open(`/patients/${groundTruth.patientId}`, '_blank')}
          >
            환자보기
          </Button>
        </ActionButtons>
      </Cell>
    </TableRow>
  );
};

const TableRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f9fafb;
  }
`;

const Cell = styled.td`
  padding: 16px;
  vertical-align: middle;
  font-size: 14px;
`;

const PatientInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const PatientId = styled.span`
  font-weight: 600;
  color: ${COLOR_SYSTEM.get("Blue")?.[400]};
`;

const PatientDetails = styled.span`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export default GroundTruthRow;
